/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The type of formatting to apply to a step.
 */
export var FormattingType;
(function (FormattingType) {
    FormattingType["DEFAULT"] = "default";
    FormattingType["LINKED"] = "linked";
    FormattingType["DIFF"] = "diff";
    FormattingType["PRIMITIVE"] = "primitive";
})(FormattingType || (FormattingType = {}));
